customElements.get("product-form") ||
  customElements.define(
    "product-form",
    class extends HTMLElement {
      constructor() {
        super();
        this.originalButtonText = "";
        this.persistentTextActive = false;
        this.onSubmitHandler = this.onSubmitHandler.bind(this);
        this.handleVariantChange = this.handleVariantChange.bind(this);
      }
      isSoldOut() {
        return this.submitButton && this.submitButton.classList.contains("sold-out");
      }
      connectedCallback() {
        this.initializationTimer = window.setTimeout(() => {
          if (!this.isConnected) return;
          if (((this.form = this.querySelector("form")), !this.form)) return;
          const t = this.variantIdInput;
          if (
            (t && (t.disabled = !1),
            this.form.addEventListener("submit", this.onSubmitHandler),
            (this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer")),
            (this.submitButton = this.querySelector('[type="submit"]')),
            this.submitButton)
          ) {
            if (
              ((this.submitButtonText = this.submitButton.querySelector(".button-text")),
              this.submitButtonText &&
                ((this.originalButtonText = this.submitButtonText.textContent),
                (this.submitButton.dataset.originalText = this.originalButtonText)),
              "true" === this.submitButton.dataset.textOverride && this.submitButtonText)
            ) {
              // Use persistent text when text override is active (never overwrite "Sold Out")
              this.persistentTextActive = !0;
              if (!this.isSoldOut()) {
                const showPrice = "true" === this.submitButton.dataset.showPrice;
                const t = this.submitButton.dataset.persistentText;
                if (t) {
                  if (!showPrice || !this.submitButtonText.textContent.trim().startsWith(t.trim())) {
                    this.submitButtonText.textContent = t;
                  }
                  localStorage.setItem("addToCartButtonText", t);
                } else {
                  const t = localStorage.getItem("addToCartButtonText");
                  if (t) {
                    if (!showPrice || !this.submitButtonText.textContent.trim().startsWith(t.trim())) {
                      this.submitButtonText.textContent = t;
                    }
                    this.submitButton.dataset.persistentText = t;
                  }
                }
              }
            }
            else if (this.submitButton.classList.contains("has-persistent-text") && this.submitButtonText) {
              this.persistentTextActive = !0;
              if (!this.isSoldOut()) {
                const showPrice = "true" === this.submitButton.dataset.showPrice;
                const t = this.submitButton.dataset.persistentText;
                if (t) {
                  if (!showPrice || !this.submitButtonText.textContent.trim().startsWith(t.trim())) {
                    this.submitButtonText.textContent = t;
                  }
                  localStorage.setItem("addToCartButtonText", t);
                } else {
                  const t = localStorage.getItem("addToCartButtonText");
                  if (t) {
                    if (!showPrice || !this.submitButtonText.textContent.trim().startsWith(t.trim())) {
                      this.submitButtonText.textContent = t;
                    }
                    this.submitButton.dataset.persistentText = t;
                  }
                }
              }
            }
            ((this.persistentTextActive || "true" === this.submitButton.dataset.textOverride) &&
              this.submitButtonText &&
              this.setupButtonTextObserver(),
              document.querySelector("cart-drawer") && this.submitButton.setAttribute("aria-haspopup", "dialog"),
              (this.hideErrors = "true" === this.dataset.hideErrors),
              document.addEventListener("variant:change", this.handleVariantChange));
          }
        }, 100);
      }
      setupButtonTextObserver() {
        if (!this.submitButtonText) return;
        const t = { characterData: !0, childList: !0, subtree: !0 };
        if (this.persistentTextActive) {
          const e = this.submitButton.dataset.persistentText || localStorage.getItem("addToCartButtonText");
          if (!e) return;
          const showPrice = "true" === this.submitButton.dataset.showPrice;
          ((this.buttonTextObserver = new MutationObserver((t) => {
            if (this.isSoldOut()) return;
            const currentText = this.submitButtonText.textContent.trim();
            const persistentText = e.trim();
            if (showPrice) {
              if (!currentText.startsWith(persistentText)) {
                this.submitButtonText.textContent = e;
              }
            } else {
              if (currentText !== persistentText) {
                this.submitButtonText.textContent = e;
              }
            }
          })),
            this.buttonTextObserver.observe(this.submitButtonText, t));
        }
      }
      handleVariantChange(t) {
        this.submitButtonText &&
          setTimeout(() => {
            if (this.isSoldOut()) return;
            if (this.persistentTextActive) {
              const showPrice = "true" === this.submitButton.dataset.showPrice;
              if (!showPrice) {
                const t = this.submitButton.dataset.persistentText || localStorage.getItem("addToCartButtonText");
                t && (this.submitButtonText.textContent = t);
              }
            }
          }, 50);
      }
      ensureSellingPlanValue() {
        let planIdToUse = null;
        try {
          const sellingPlanInput = this.form.querySelector('input[name="selling_plan"]');
          if (sellingPlanInput) {
            if (sellingPlanInput.value) {
              planIdToUse = sellingPlanInput.value;
            } else {
              const subscribeToggle = document.querySelector('.subscribe-save-wrapper input[type="checkbox"]:checked, .subscribe-save-wrapper-dynamic input[type="checkbox"]:checked');
              if (subscribeToggle) {
                const wrapper = subscribeToggle.closest('.subscribe-save-wrapper, .subscribe-save-wrapper-dynamic');
                if (wrapper) {
                  planIdToUse = wrapper.dataset.sellingPlanId || subscribeToggle.dataset.planId;
                }
                
                if (planIdToUse) {
                  sellingPlanInput.value = planIdToUse;
                  sellingPlanInput.setAttribute('value', planIdToUse);
                }
              }
            }
          }
        } catch (error) {
          console.warn('⚠️ product-form.js: Error setting selling_plan:', error);
        }
        return planIdToUse;
      }
      async onSubmitHandler(event) {
        event.preventDefault();
        if (!this.submitButton || this.submitButton.getAttribute("aria-disabled") === "true") return;

        const finishCartWork = window.fourPawCartWork?.begin();
        if (window.fourPawCartWork && !finishCartWork) return;

        let uncertainCart = false;
        try {
          this.handleErrorMessage();
          this.submitButton.setAttribute("aria-disabled", "true");
          this.submitButton.classList.add("loading");
          this.querySelector(".loading__spinner")?.classList.remove("hidden");

          const requestConfig = fetchConfig("javascript");
          requestConfig.headers["X-Requested-With"] = "XMLHttpRequest";
          delete requestConfig.headers["Content-Type"];
          this.ensureSellingPlanValue();

          const formData = new FormData(this.form);
          this.form.dispatchEvent(
            new CustomEvent("fourpaw:product-form-data", { detail: { formData } }),
          );
          if (this.cart) {
            formData.append("sections", this.cart.getSectionsToRender().map((section) => section.id));
            formData.append("sections_url", window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          requestConfig.body = formData;

          const request = window.fourPawCartFetch || window.fetch.bind(window);
          const response = await request(`${routes.cart_add_url}`, requestConfig);
          const responseData = await response.json();
          if (!response.ok && !responseData.status) {
            responseData.status = response.status;
            responseData.description = responseData.description || window.cartStrings.error;
          }
          await this.handleCartResponse(formData, responseData);
        } catch (error) {
          uncertainCart = true;
          window.fourPawCartWork?.fail();
          this.dispatchEvent(
            new CustomEvent("fourpaw:product-form:add-to-cart-failed", {
              bubbles: true,
              detail: { failureCategory: error?.name === "CartTimeoutError" ? "timeout" : "network" },
            }),
          );
          this.handleErrorMessage(window.cartStrings.error);
          console.error(error);
        } finally {
          this.handleSubmitFinally(event);
          finishCartWork?.();
          if (uncertainCart) await window.fourPawCartWork?.recover();
        }
      }
      async handleCartResponse(formData, responseData) {
        if (responseData.status) {
          this.error = !0;
          this.dispatchEvent(
            new CustomEvent("fourpaw:product-form:add-to-cart-failed", {
              bubbles: true,
              detail: {
                failureCategory: Number(responseData.status) === 422 ? "availability" : "validation",
              },
            }),
          );
          (publish(PUB_SUB_EVENTS.cartError, {
            source: "product-form",
            productVariantId: formData.get("id"),
            errors: responseData.errors || responseData.description,
            message: responseData.message,
          }),
            this.handleErrorMessage(responseData.description));
          const e = this.submitButton.querySelector(".sold-out-message");
          if (!e) return;
          return (
            this.submitButton.setAttribute("aria-disabled", !0),
            this.submitButtonText.classList.add("hidden"),
            e.classList.remove("hidden")
          );
        }
        const addedItems = Array.isArray(responseData.items) ? responseData.items : [responseData];
        this.dispatchEvent(
          new CustomEvent("fourpaw:product-form:add-to-cart-accepted", {
            bubbles: true,
            detail: { lineCount: addedItems.length },
          }),
        );
        if (!this.cart) return void (window.location = window.routes.cart_url);
        this.error = false;
        const renderAndReconcile = async () => {
          CartPerformance.measure("add:paint-updated-sections", () => {
            this.cart.renderContents(responseData);
          });
          const controller =
            this.cart.querySelector?.("cart-drawer-items") || document.querySelector("cart-items");
          const eventDetail = {
            source: "product-form",
            productVariantId: formData.get("id"),
            sectionsRendered: true,
          };
          const marker = CartPerformance.createStartingMarker("add:reconcile-cart");
          try {
            if (controller?.normalizeFourPawSafeWalkCart && controller?.fourPawRefreshCart) {
              const normalized = await controller.normalizeFourPawSafeWalkCart();
              await controller.fourPawRefreshCart(normalized.cart, false, false, eventDetail);
            } else {
              await Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, {
                ...eventDetail,
                cartData: responseData,
              }));
            }
            this.dispatchEvent(new CustomEvent("fourpaw:product-form:add-to-cart-succeeded", {
              bubbles: true, detail: { lineCount: addedItems.length },
            }));
          } catch (error) {
            window.fourPawCartWork?.fail();
            this.dispatchEvent(new CustomEvent("fourpaw:product-form:cart-sync-failed", { bubbles: true }));
            console.error("Unable to synchronize the updated cart:", error);
          } finally {
            CartPerformance.measureFromMarker("add:reconcile-cart", marker);
          }
        };
        const quickAddModal = this.closest("quick-add-modal");
        if (!quickAddModal) {
          await renderAndReconcile();
          return;
        }

        await new Promise((resolve) => {
          let reconciled = false;
          const run = async () => {
            if (reconciled) return;
            reconciled = true;
            window.clearTimeout(fallbackTimer);
            await renderAndReconcile();
            resolve();
          };
          document.body.addEventListener("modalClosed", run, { once: true });
          const fallbackTimer = window.setTimeout(run, 1500);
          quickAddModal.hide(true);
        });
      }
      handleSubmitFinally(event) {
        if (
          (this.submitButton.classList.remove("loading"),
          !this.error &&
            this.cart &&
            this.cart.classList.contains("is-empty") &&
            this.cart.classList.remove("is-empty"),
          this.error || this.submitButton.removeAttribute("aria-disabled"),
          this.querySelector(".loading__spinner")?.classList.add("hidden"),
          this.error || "true" !== this.submitButton.dataset.textOverride)
        ) {
          if (!this.error && this.persistentTextActive && !this.isSoldOut()) {
            const showPrice = "true" === this.submitButton.dataset.showPrice;
            const t = this.submitButton.dataset.persistentText || localStorage.getItem("addToCartButtonText");
            if (t && this.submitButtonText) {
              if (!showPrice || !this.submitButtonText.textContent.trim().startsWith(t.trim())) {
                this.submitButtonText.textContent = t;
              }
            }
          }
        } else;
        CartPerformance.measureFromEvent("add:user-action", event);
      }
      handleErrorMessage(t = !1) {
        this.hideErrors ||
          ((this.errorMessageWrapper =
            this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper")),
          this.errorMessageWrapper &&
            ((this.errorMessage =
              this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message")),
            this.errorMessageWrapper.toggleAttribute("hidden", !t),
            t && (this.errorMessage.textContent = t)));
      }
      toggleSubmitButton(t = !0, e) {
        if (t) (this.submitButton.setAttribute("disabled", "disabled"), e && (this.submitButtonText.textContent = e));
        else {
          if ((this.submitButton.removeAttribute("disabled"), "true" === this.submitButton.dataset.textOverride));
          else if (this.persistentTextActive) {
            const t = this.submitButton.dataset.persistentText || localStorage.getItem("addToCartButtonText");
            if (t) return void (this.submitButtonText.textContent = t);
          }
          this.originalButtonText
            ? (this.submitButtonText.textContent = this.originalButtonText)
            : this.submitButton.dataset.originalText
              ? (this.submitButtonText.textContent = this.submitButton.dataset.originalText)
              : (this.submitButtonText.textContent = window.variantStrings.addToCart);
        }
      }
      disconnectedCallback() {
        window.clearTimeout(this.initializationTimer);
        this.form?.removeEventListener("submit", this.onSubmitHandler);
        this.buttonTextObserver?.disconnect();
        document.removeEventListener("variant:change", this.handleVariantChange);
      }
      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    },
  );
